import React from 'react';

const WhatsappLogoIcon = () => {
    return (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g id="WhatsappLogo">
                <path
                    id="Vector"
                    d="M4.25895 16.5936C3.14076 14.7086 2.74916 12.4802 3.15768 10.327C3.56621 8.17366 4.74675 6.24356 6.47764 4.89909C8.20852 3.55462 10.3707 2.88826 12.5581 3.02514C14.7455 3.16202 16.8078 4.09273 18.3575 5.6425C19.9073 7.19226 20.838 9.25448 20.9749 11.4419C21.1118 13.6293 20.4455 15.7915 19.101 17.5224C17.7565 19.2533 15.8264 20.4338 13.6732 20.8424C11.5199 21.2509 9.29149 20.8593 7.40649 19.7411L7.40651 19.741L4.29808 20.6292C4.16948 20.6659 4.03338 20.6676 3.90391 20.634C3.77443 20.6005 3.65628 20.5329 3.56171 20.4384C3.46713 20.3438 3.39956 20.2256 3.36601 20.0961C3.33246 19.9667 3.33415 19.8306 3.37089 19.702L4.25902 16.5935L4.25895 16.5936Z"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    id="Vector_2"
                    d="M14.2607 17.25C13.274 17.2514 12.2967 17.0581 11.3848 16.6811C10.4729 16.3042 9.64441 15.751 8.9467 15.0533C8.24899 14.3556 7.69582 13.5271 7.31887 12.6152C6.94192 11.7033 6.74861 10.726 6.75001 9.73934C6.75224 9.04482 7.02986 8.37953 7.52196 7.88943C8.01406 7.39932 8.68047 7.12441 9.375 7.125V7.125C9.48892 7.125 9.60081 7.15512 9.69934 7.21229C9.79787 7.26947 9.87953 7.35168 9.93605 7.45059L11.0321 9.36865C11.0982 9.48432 11.1323 9.61551 11.1309 9.74873C11.1294 9.88195 11.0926 10.0124 11.024 10.1266L10.1438 11.5937C10.5967 12.5986 11.4014 13.4033 12.4063 13.8562V13.8562L13.8734 12.976C13.9876 12.9074 14.118 12.8706 14.2513 12.8691C14.3845 12.8677 14.5157 12.9018 14.6313 12.9679L16.5494 14.064C16.6483 14.1205 16.7305 14.2021 16.7877 14.3007C16.8449 14.3992 16.875 14.5111 16.875 14.625V14.625C16.873 15.3187 16.5973 15.9837 16.1077 16.4752C15.6182 16.9667 14.9544 17.2452 14.2607 17.25V17.25Z"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </g>
        </svg>
    );
};

export default WhatsappLogoIcon;
